import * as Types from 'src/actions/project/index/Types';
import Project from 'src/entities/Project';
import { IndexProjectsAction, IndexProjectsSuccess } from 'src/actions/project/index/IndexProjects.actions';

export interface IndexProjectsState {
  projectsLists: {
    [key: string]: Project[];
  };
  loading: boolean;
  error: boolean;
}

const initialState: IndexProjectsState = {
  projectsLists: {},
  loading: false,
  error: false,
};

export function IndexProjectsReducer(state: IndexProjectsState = initialState,
                                     action: IndexProjectsAction): IndexProjectsState {
  switch (action.type) {
    case Types.INDEX_PROJECTS_ATTEMPT:
      return {...state, loading: true, error: false};
    case Types.INDEX_PROJECTS_SUCCESS:
      const projects = (action as IndexProjectsSuccess).payload.projects;
      const key = (action as IndexProjectsSuccess).payload.key;
      const newList: { [key: string]: Project[]; } = {};
      newList[key] = projects;
      return {...state, projectsLists: {...state.projectsLists, ...newList}, loading: false, error: false};
    case Types.INDEX_PROJECTS_FAILURE:
      return {...state, loading: false, error: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/IndexProjectsReducer.tsx